import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { FRONT_URL } from 'src/app/constant/app-constant';

@Injectable({
  providedIn: 'root'
})
export class MetaTagsService {

  constructor(@Inject(DOCUMENT) private dom: any, private meta: Meta) { }

  setMetaTags(tags: string) {

    tags.split(",").forEach((e) => {

      this.meta.addTags([
        { property: 'article:tag', content: e },
      ])
    })
  }
  destroyTags() {
    const els = this.dom.querySelectorAll('meta[property=\'article:tag\']');
    for (let i = 0, l = els.length; i < l; i++) {
      const el = els[i];
      el.remove();
    }
  }

  setOgTags(title: string, desc: string, image: string, url: string) {


    this.meta.updateTag({ property: 'og:type', content: "article" })
    this.meta.updateTag({ property: 'og:title', content: title })
    this.meta.updateTag({ property: 'og:description', content: desc })
    this.meta.updateTag({ property: 'og:image', content: image })
    this.meta.updateTag({ property: 'og:image:secure_url', content: image })
    this.meta.updateTag({ property: 'og:url', content: FRONT_URL + url })

    this.meta.updateTag({ name: 'twitter:title', content: title })
    this.meta.updateTag({ name: 'twitter:description', content: desc })
    this.meta.updateTag({ name: 'twitter:image:src', content: image })

    //   this.meta.addTags([
    //     { property: 'og:locale', content: 'en_US' },
    //     { property: 'og:type', content: 'article' },
    //     { property: 'og:title', content: title },
    //     { property: 'og:description', content: desc },
    //     { property: 'og:url', content: "http://34.100.175.63:4000/2022/25/4/srilankan-airlines-top-board-to-appear-at-cope" },
    //     { property: 'og:site_name', content: 'Sri Lanka News - Newsfirst' },
    //     { property: 'og:image', content: image },
    //     { property: 'fb:app_id', content: ' 49804646831820' },
    //   ])
  }


}


